import { render, staticRenderFns } from "./StrukA4.vue?vue&type=template&id=13756d59&scoped=true&"
import script from "./StrukA4.vue?vue&type=script&lang=js&"
export * from "./StrukA4.vue?vue&type=script&lang=js&"
import style0 from "./StrukA4.vue?vue&type=style&index=0&id=13756d59&lang=scss&scoped=true&"
import style1 from "./StrukA4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13756d59",
  null
  
)

export default component.exports